import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const FinanceCalculator = () => {
  const [vehiclePrice, setVehiclePrice] = useState(2000000);
  const [depositPercent, setDepositPercent] = useState(20);
  const [loanTerm, setLoanTerm] = useState(12);
  const [interestRate, setInterestRate] = useState(14);

  const downPayment = vehiclePrice * (depositPercent / 100);
  const loanAmount = vehiclePrice - downPayment;

  const monthlyRate = interestRate / 100 / 12;

  const monthlyPayment =
    monthlyRate === 0
      ? loanAmount / loanTerm
      : (loanAmount *
          monthlyRate *
          Math.pow(1 + monthlyRate, loanTerm)) /
        (Math.pow(1 + monthlyRate, loanTerm) - 1);

  const totalRepayment = monthlyPayment * loanTerm;
  const totalInterest = totalRepayment - loanAmount;

  const formatCurrency = (amount) =>
    amount.toLocaleString("en-KE", {
      maximumFractionDigits: 0,
    });

  return (
    <section className="finance-calculator-section">
      <div className="top-header">
        <span>Finance Calculator</span>
        <h2>Estimate Your Monthly Vehicle Repayments</h2>

        <p>
          Adjust the vehicle price, deposit amount, loan term and
          interest rate to estimate your repayments.
        </p>
      </div>

      <div className="finance-calc-wrapper">

        {/* LEFT */}

        <div className="finance-inputs">

          <div className="input-group">
            <label className="finance-values">
              <span>Vehicle Price</span>
              <h3>KSh {formatCurrency(vehiclePrice)}</h3>
            </label>

            <input
              type="range"
              min="500000"
              max="10000000"
              step="50000"
              value={vehiclePrice}
              onChange={(e) =>
                setVehiclePrice(Number(e.target.value))
              }
            />

            <div className="range-labels">
              <span>KSh 500K</span>
              <span>KSh 10M</span>
            </div>
          </div>

          <div className="input-group">
            <label className="finance-values">
              <span>Down Payment</span>

              <h3>
                {depositPercent}%{" "}
                <small>
                  KSh {formatCurrency(downPayment)}
                </small>
              </h3>
            </label>

            <input
              type="range"
              min="10"
              max="90"
              step="5"
              value={depositPercent}
              onChange={(e) =>
                setDepositPercent(Number(e.target.value))
              }
            />

            <div className="range-labels">
              <span>10%</span>
              <span>90%</span>
            </div>
          </div>

          <div className="input-group">
            <label>Loan Term</label>

            <div className="term-buttons">
              {[12, 24, 36, 48, 60].map((term) => (
                <button
                  key={term}
                  className={
                    loanTerm === term
                      ? "term-btn active"
                      : "term-btn"
                  }
                  onClick={() => setLoanTerm(term)}
                >
                  {term}mo
                </button>
              ))}
            </div>
          </div>

          <div className="input-group">
            <label className="finance-values">
              <span>Interest Rate (Annual)</span>

              <h3>{interestRate}%</h3>
            </label>

            <input
              type="range"
              min="5"
              max="30"
              step="0.5"
              value={interestRate}
              onChange={(e) =>
                setInterestRate(Number(e.target.value))
              }
            />

            <div className="range-labels">
              <span>5%</span>
              <span>30%</span>
            </div>
          </div>

        </div>

        {/* RIGHT */}

        <div className="finance-results">

          <div className="monthly-card">
            <span>ESTIMATED MONTHLY</span>

            <h2>
              KSh {formatCurrency(monthlyPayment)}
            </h2>

            <p>
              per month for {loanTerm} months
            </p>
          </div>

          <div className="summary-card">

            <div className="summary-row">
              <span>Car Price</span>
              <strong>
                KSh {formatCurrency(vehiclePrice)}
              </strong>
            </div>

            <div className="summary-row">
              <span>Down Payment</span>
              <strong>
                KSh {formatCurrency(downPayment)}
              </strong>
            </div>

            <div className="summary-row">
              <span>Loan Amount</span>
              <strong>
                KSh {formatCurrency(loanAmount)}
              </strong>
            </div>

            <div className="summary-row">
              <span>Total Interest</span>
              <strong>
                KSh {formatCurrency(totalInterest)}
              </strong>
            </div>

            <div className="summary-row total">
              <span>Total Repayment</span>
              <strong>
                KSh {formatCurrency(totalRepayment)}
              </strong>
            </div>

          </div>

          <a
            href={`https://wa.me/254753864153?text=Hello%20Matel%20Trading%20Motors,%20I%20would%20like%20vehicle%20financing.%0A%0AVehicle%20Price:%20KSh%20${vehiclePrice}%0ADeposit:%20${depositPercent}%25%0ALoan%20Term:%20${loanTerm}%20Months`}
            target="_blank"
            rel="noopener noreferrer"
            className="finance-whatsapp-btn"
          >
            <FaWhatsapp />
            Get A Personalised Quote
          </a>

        </div>

      </div>
    </section>
  );
};

export default FinanceCalculator;